<template lang="pug">
.app
    .loading-page(v-if="loading")
        a-spin(style="width:100%;height:100vh;padding-top:120px" size="large" tip="加载中..." :spinning="loading")

    template(v-else)
        .content 
            slot
</template>

<script>


export default {
    props: ['itemId'],
    data() {
        return {
            loading: true,
            id: this.itemId || this.getQueryParams().id,
            name: '',
            pltOptions: [],
        };
    },
    created() {
        this.$api.request('GET', 'me').then(res => {
            this.getFileInfo();
        })
        .catch(err => {
            
            this.getFileInfo();
                        
        })
        
        
    },
    watch: {
        itemId(val) {
            if (val) {
                this.id = val;
                this.loading = true;
                this.getFileInfo();
            }
        }
    },
    methods: {
        getQueryParams() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const params = {};

            urlParams.forEach((value, key) => {
                // 处理重复参数，将其存储为数组
                if (params[key] !== undefined) {
                    if (!Array.isArray(params[key])) {
                        params[key] = [params[key]];
                    }
                    params[key].push(value);
                } else {
                    params[key] = value;
                }
            });

            if (!params.id && !this.itemId) {
                this.$message.error({content: '无效链接', duration: 0});
            }

            return params;
        },
        getFileInfo() {
            
            this.$api.request('GET', 'detail/' + this.id, {}, 'fs').then(res => {
                this.name = res.data.name;
                this.pltOptions = res.data.pltOptions;
                this.loading = false;
                // 设置网页标题
                document.title = this.name;
                
                this.$emit('loaded', {
                    name: this.name,
                    pltOptions: this.pltOptions,
                    id: this.id,
                    language: this.language(this.name),
                });
            })
            .catch(err => {
                this.$message.error({content: '获取文件信息失败', duration: 0});
            })
            
        },
        language(name) {
            if (/.(py)$/i.test(name)) {
                return 'python';
            }
            else if (/.(js)$/i.test(name)) {
                return 'javascript';
            }
            else if (/.(txt)$/i.test(name)) {
                return 'plain';
            }
            

            return 'plain';
        },
    },
    computed: {
        fileType() {
            let name = this.name;
            if (/.csv$/i.test(name)) {
                return 'csv';
            }
            else if (/.(jpg|png|jpeg)$/i.test(name)) {
                return 'img';
            }
            else if (/.(xlsx|docx)$/i.test(name)) {
                return 'office';
            }
            else if (/.pdf$/i.test(name)) {
                return 'pdf';
            }
            else if (/.(py|js|txt)$/i.test(name)) {
                return 'code';
            }
            else if (/.(market)$/i.test(name)) {
                return 'market';
            }
            
            return 'other';
        
        }
    },
    components: {
        
    }
}
</script>
<style lang="less" scoped>
.loading-page {
    text-align: center;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    // margin-bottom: 20px;
    // padding: 300px 50px;
    // margin: 20px 0;
}
</style>